import { ASSIGMENTS_ORDERS, ASSIGMENTS_ORDERS_ERROR } from '_models/redux/types';
import axiosTokenInstance from 'services/api/backoffice';

// Action function
export const getOrdersAssignments = (params) => async (dispatch) => {
  const { carrier_id, legal_id } = params || {};

  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.get(
      `/api/companies/${legal_id}/linked-up/orders?carrier_id=${carrier_id}`,
    );

    const { data, status } = response || {};

    dispatch({
      method: 'get',
      payload: data || {},
      status: status || {},
      type: ASSIGMENTS_ORDERS,
    });
  } catch (e) {
    dispatch({
      method: 'get',
      payload: e || {},
      type: ASSIGMENTS_ORDERS_ERROR,
    });
  }
};
